export default __webpack_public_path__ + "static/media/3233 knife block B side.2d491f4a.png";